<template>
  <div class="swiper_warp">
    <div v-if="listData.length < 6" style="display: flex;">
      <div class="swiper_item" :class="active == item.lxId ? 'active' : ''" v-for="item in listData" :key="item.lxId" @click="hangleSwiper(item.lxId)">
        <div class="item_img" :class="active == item.lxId ? 'activeTwo' : ''">
          <img :src="item.lxIcon" alt="">
        </div>
        <div class="item_text">{{item.lxName}}</div>
      </div>
    </div>
    <div v-else style="display: flex; width: 100%; flex-wrap: wrap;">
      <div class="item_many" :class="active == item.lxId ? 'activeMany' : ''" v-for="item in listData" :key="item.lxId" @click="hangleSwiper(item.lxId)">
        <div class="many_img">
          <img :src="item.lxIcon" alt="">
        </div>
        <div class="many_text">{{item.lxName}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Bus from "@/common/js/bus.js"
  export default {
    data() {
      return{
        active:0,  //点击切换培训
        listData:[],  //切换的数据类型
      }
    },
	mounted() {
		this.getDataList();
	},
    methods:{
      // 点击切换培训内容
      hangleSwiper(id){
        if(id){
          Bus.$emit("hangleId",id);
          this.$store.state.kclx = id;
        }else{
          Bus.$emit("hangleId",this.active);
          this.$store.state.kclx = this.active;
        }
        this.active = id;
      },
	  // 类型列表提交排序
	  getDataList(){
	    let _self = this;
	    let ajax = _self.$http.create();
	    const loading = _self.$loading({
	      lock: true,
	      spinner: 'el-icon-loading',
	      background: 'rgba(255, 255, 255, 0.5)'
	    });
	    ajax({
	        method: "get",
	        url: SOWINURL + "index/lxList",
	        data: {
	        },
	      })
	      .then(function(json) {
	        if (json.data.result == 1) {
            _self.listData = json.data.data;
            _self.active = _self.listData[0].lxId;
            // _self.$store.state.xzlb = _self.active;
            // _self.hangleSwiper();
	        } else {
	          _self.$message({
	            showClose: true,
	            message: json.data.errorcode,
	            type: "error"
	          });
	        }
	        loading.close();
	      })
	      .catch(function(error) {
	        console.log(error);
	      });
	  },
    }
  }
</script>

<style scoped lang="less">
  .swiper_warp{
    display: flex;
    align-items: center;
    width: 1210px;
    margin: 0 auto;
    padding-bottom: 110px;
    padding-top: 98px;
    cursor: pointer;
    .swiper_item{
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .item_img{
        width: 120px;
        height: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(233,239,246);
        border-radius: 50%;
      }

      .activeTwo{
        border:1px solid #0076FF;
        background-color: transparent;
      }

      .item_text{
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        margin-top: 10px;
      }
    }
    .swiper_item:nth-child(n+2){
      margin-left: 100px;
    }
    .active{
      width: 200px;
      height: 240px;
      background-color: #fff;
    }


    // 多个培训
    .item_many{
      width: 260px;
      display: flex;
      align-items: center;
      // justify-content: center;
      margin-bottom: 36px;
      .many_img{
        width: 40px;
        height: 40px;
        border: 1px solid #0076FF;
        border-radius:50%;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          display: inline-block;
          width: 18px;
        }
      }
      .many_text{
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        margin-left: 10px;
      }
    }
    // .item_many:nth-child(n+2){
    //   margin-left: 58px;
    // }
    .activeMany{
      width: 260px;
      height: 72px;
      background-color: #fff;
      border-radius: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index_swiper.vue